import React from "react"
import { Link } from "gatsby"

const ButtonContact = ({ children, setIsOpen, setIsMessage, message }) => {
  return (
    <button
      onClick={() => {
        setIsOpen(true)
        setIsMessage(message)
      }}
      className="w-full rounded-full border border-white bg-transparent py-5 px-10 font-bold text-white transition-colors hover:bg-white hover:text-eido-grey-900 md:text-2xl"
    >
      {children}
    </button>
  )
}

const Footer = ({ setIsOpen, setIsMessage }) => {
  return (
    <footer className="relative mt-20 overflow-hidden bg-eido-grey-900">
      {/* Gradient décoratif — pas d'image externe */}
      <div
        className="absolute inset-0 opacity-30"
        style={{
          background:
            "radial-gradient(ellipse at 20% 50%, rgba(253,89,73,0.4) 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, rgba(40,90,235,0.4) 0%, transparent 60%)",
        }}
        aria-hidden="true"
      />

      <div className="container relative mx-auto">
        <div className="py-8 md:py-32">
          <div className="text-center text-3xl font-bold uppercase text-white drop-shadow-2xl md:text-7xl">
            <span className="block">Et si on parlait</span>
            <span className="block">d'avenir&nbsp;?</span>
          </div>
        </div>
        <div className="flex flex-col gap-4 px-8 md:flex-row md:gap-16 md:px-2">
          <ButtonContact
            setIsOpen={setIsOpen}
            setIsMessage={setIsMessage}
            message={true}
          >
            M'envoyer un message
          </ButtonContact>
          <ButtonContact setIsOpen={setIsOpen} setIsMessage={setIsMessage}>
            Démarrer un nouveau projet
          </ButtonContact>
        </div>
      </div>

      <div className="container relative mx-auto px-4 pt-32 pb-8 text-center text-xs text-eido-grey-500">
        © eidolon design 2022 — <Link to="/mentions-legales/" className="hover:text-eido-grey-200 transition-colors">mentions légales</Link>
      </div>
    </footer>
  )
}

export default Footer
